export const roleNames = {
  default: 'Padrão',
  admin: 'Administrador',
  root: 'Super',
}
